






















import { Component, Prop, Vue } from "vue-property-decorator";

import { CookieHelper } from "@/helper/cookieHelper";
import { DateHelper } from "@/helper/dateHelper";
import { CloudHelper } from "@/helper/cloudHelper";
import { DebugHelper } from "@/helper/debugHelper";
import { RequestHelper } from "@/helper/requestHelper";
import { UserAgentHelper } from "@/helper/userAgentHelper";

import { Const } from "@/const";
import { CloudAccount } from "@/cloudAccount/cloudAccount";
import { CloudOperation } from '@/cloudOperation/cloudOperation';

import SignInScreen from "./signInScreen/signInScreen.vue";
import OnetimePass from "../userRegistration/onetimePass/onetimePass.vue";
import Questionnaire from "../userRegistration/questionnaire/questionnaire.vue";
import InputMail from "./inputMail/inputMail.vue";
import InputPassword from "./inputPassword/inputPassword.vue";
import License from "../top2/mainContents/license/license.vue";
import TimeoutModal from "../cloud/cloudModal/timeoutModal.vue";

@Component({
  components: {
      SignInScreen,
      OnetimePass,
      Questionnaire,
      InputMail,
      InputPassword,
      License,
      TimeoutModal
  }
})

export default class SignIn extends Vue {

    isSignInScreen = true;
    isOnetimePass = false;
    isQuestionnaire = false;
    isInputMail = false;
    isLicense = false;
    isTimeoutModalVisivle = false;

    mail = "";
    password = "";
    isError = false;
    errorMessages = new Array();


    private mounted(){
        if(CookieHelper.getItem("license") != true){
            this.isLicense = true;
        }

        if(this.cloudAccount.signOutType == 2){
            this.isTimeoutModalVisivle = true;
        }
        DebugHelper.trace("signIn");
        DebugHelper.trace(this.$router.currentRoute);
    }

    private onDoCommand(command : string, param : any){
        if(command == "signIn"){
            this.signIn(param);
        }
        else if(command == "onetimePass"){
            this.onetimePass(param);
        }
        else if(command == "questionnaire"){
            this.questionnaire(param);
        }
        else if(command == "createAccount"){
            this.createAccount();
        }
        else if(command == "forgotPassword"){
            this.forgotPassword();
        }
        else if(command == "returnPage"){
            this.returnPage();
        }
        else if(command == "sendMail"){
            this.sendMail(param);
        }
        else if(command == "reregistrationPassword"){
            this.reregistrationPassword(param);
        }
    }

    private get cloudAccount() : CloudAccount
    {
      	return this.$store.getters.cloudAccount;
    }

    private returnPage(){
        if(this.cloudAccount.signOutType == 3){
            DebugHelper.trace(this.$store.getters.cloudOperation);
            this.$router.push(this.cloudOperation.returnPage);
        }
        else{
            history.back();
        }
    }

    // ログイン処理
    private signIn(param){
        RequestHelper.post("sign_in", param, (response) => {
            var res : any = JSON.parse(response);
            DebugHelper.trace(res);
            if(res.message.length > 0){
                this.isError = true;
                this.errorMessages = new Array();
                for(var i = 0; i < res.message.length; i++){
                    this.errorMessages.push({index: i, message: res.message[i]});
                }
            }
            else{
                DebugHelper.trace(res.data);
                CookieHelper.setItem("certificationToken", res.data.certificationToken);

                // loginType == 1でログイン == 2でワンタイムパス入力
                if(res.data.loginType == 1){
                    CookieHelper.setItem("authorizationToken", res.data.authorizationToken);
                    CookieHelper.setItem("accessToken", res.data.accessToken);
                    CookieHelper.setItem("refreshToken", res.data.refreshToken);
                    CookieHelper.setItem("accessLimit", res.data.accessLimit);
                    CookieHelper.setItem("refreshLimit", res.data.refreshLimit);

                    this.cloudAccount.isSignIn = true;
                    CloudHelper.cloudSignOutTimer(this.cloudAccount);
                    CloudHelper.updateRefreshTokenTimer(this.cloudAccount);

                    // クラウドページに飛ぶ
                    this.$router.push("/" + this.cloudAccount.toGo);
                }
                else{
                    this.isError = false;
                    this.errorMessages = new Array();
                    this.isSignInScreen = false;
                    this.isOnetimePass = true;
                }
            }
        }, () => {
            DebugHelper.trace("エラー");
        });
    }

    // ワンタイムパス入力
    private onetimePass(param){
        RequestHelper.post("check_onetime", param, (response) => {
            var res : any = JSON.parse(response);
            DebugHelper.trace(res);
            if(res.message.length > 0){
                this.isError = true;
                this.errorMessages = new Array();
                for(var i = 0; i < res.message.length; i++){
                    this.errorMessages.push({index: i, message: res.message[i]});
                }
            }
            else{
                CookieHelper.setItem("accessToken", res.data.accessToken);
                CookieHelper.setItem("refreshToken", res.data.refreshToken);
                CookieHelper.setItem("accessLimit", res.data.accessLimit);
                CookieHelper.setItem("refreshLimit", res.data.refreshLimit);
                CookieHelper.setItem("authorizationToken", res.data.authorizationToken);

                this.cloudAccount.isSignIn = true;
                CloudHelper.cloudSignOutTimer(this.cloudAccount);
                CloudHelper.updateRefreshTokenTimer(this.cloudAccount);

                this.$router.push("/" + this.cloudAccount.toGo);
            }
        }, () => {
            DebugHelper.trace("エラー");
        });
    }

    private questionnaire(param){
        RequestHelper.post("questionnaire", param, (response) => {
            var res : any = JSON.parse(response);
            DebugHelper.trace(res);
            if(res.message.length > 0){
                this.isError = true;
                this.errorMessages = new Array();
                for(var i = 0; i < res.message.length; i++){
                    this.errorMessages.push({index: i, message: res.message[i]});
                }
            }
            else{
                CookieHelper.setItem("authorizationToken", res.data.authorizationToken);
                CookieHelper.setItem("accessToken", res.data.accessToken);
                CookieHelper.setItem("refreshToken", res.data.refreshToken);
                CookieHelper.setItem("accessLimit", res.data.accessLimit);
                CookieHelper.setItem("refreshLimit", res.data.refreshLimit);

                this.$router.push("/" + this.cloudAccount.toGo);
            }
        }, () => {
            DebugHelper.trace("エラー");
        });
    }

    private createAccount(){
        this.$router.push("/UserRegistration");
    }

    private forgotPassword(){
        this.isError = false;
        this.errorMessages = new Array();
        this.isSignInScreen = false;
        this.isInputMail = true;
    }

    // パスワード忘れた時のワンタイムパス発行
    private sendMail(param){
        RequestHelper.post("send_reset_onetime", param, (response) => {
            var res : any = JSON.parse(response);
            DebugHelper.trace(res);
            if(res.message.length > 0){
                this.isError = true;
                this.errorMessages = new Array();
                for(var i = 0; i < res.message.length; i++){
                    this.errorMessages.push({index: i, message: res.message[i]});
                }
            }
            else{
                this.isError = false;
                this.errorMessages = new Array();

                CookieHelper.setItem("certificationToken", res.data.certificationToken);
                this.isInputMail = false;
            }
        }, () => {
            DebugHelper.trace("エラー");
        });
    }

    // ワンタイムパスでパスワードの再設定
    private reregistrationPassword(param){
        RequestHelper.post("reset_password", param, (response) => {
            var res : any = JSON.parse(response);
            DebugHelper.trace(res);
            if(res.message.length > 0){
                this.isError = true;
                this.errorMessages = new Array();
                for(var i = 0; i < res.message.length; i++){
                    this.errorMessages.push({index: i, message: res.message[i]});
                }
            }
            else{
                CookieHelper.setItem("authorizationToken", res.data.authorizationToken);
                CookieHelper.setItem("accessToken", res.data.accessToken);
                CookieHelper.setItem("refreshToken", res.data.refreshToken);
                CookieHelper.setItem("accessLimit", res.data.accessLimit);
                CookieHelper.setItem("refreshLimit", res.data.refreshLimit);

                this.cloudAccount.isSignIn = true;
                CloudHelper.cloudSignOutTimer(this.cloudAccount);
                CloudHelper.updateRefreshTokenTimer(this.cloudAccount);
                this.$router.push("/" + this.cloudAccount.toGo);
            }
        }, () => {
            DebugHelper.trace("エラー");
        });
    }

    private encodeHTMLForm(data : any){
        var params = new Array();

        for(var name in data){
            var value = data[name];
            var param = encodeURIComponent( name ) + '=' + encodeURIComponent( value );

            params.push( param );
        }
        return params.join( '&' ).replace( /%20/g, '+' );
    }

    private get cloudOperation() : CloudOperation
    {
      	return this.$store.getters.cloudOperation;
    }

    private get device(){
        return UserAgentHelper.getDevice();
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigButtonColor(){
        var style = {
            backgroundColor: this.userConfigColor
        };
        return style;
    }
    private get userConfigUnderLineColor(){
        var style = {
            borderBottom: "solid 1px " + this.userConfigColor
        };
        return style;
    }
}
